export const TikTokIcon = ({ size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M16.5 3c.3 2.2 1.6 3.9 3.9 4.2v2.7c-1.4.1-2.7-.3-3.9-1v6.4c0 3.3-2.5 5.7-5.6 5.7-3.2 0-5.4-2.6-5.4-5.5 0-3.2 2.6-5.4 6-5.1v2.8c-.5-.1-1-.2-1.5-.1-1.2.2-2 1-1.9 2.3.1 1.2 1 2 2.2 2 1.3 0 2.1-1 2.1-2.5V3h3.6z" />
  </svg>
);
